<template>
  <div class="main-wraper">
    <Header/>
    <section class="content-area">
      <MainMenu/>
      <div class="content-indent-wrapper">
        <div class="content-indent">
          <div class="breadcrumbs">
            <router-link :to="{name: 'LK/conclusions'}">Реестр заключений</router-link>
            &gt;
            <span>Заявка рег. № {{ conclusionItem.REQUEST.UF_NUMBER }}</span>
          </div>
          <div class="page-top-title" v-if="!isConclusionsLoading">
            <div class="page-top-title__item">
              <h2 class="content-title" style="max-width: 500px">
                Заявка рег. № {{ conclusionItem.REQUEST.UF_NUMBER }} от {{ conclusionItem.REQUEST.UF_DATE_SEND }};
                Договор № {{ conclusionItem.REQUEST.DOGOVOR.NUMBER }}
                от {{ conclusionItem.REQUEST.DOGOVOR.DATE }};
                ТЗ № {{ conclusionItem.TZ.NUMBER }} от {{ conclusionItem.TZ.DATE	}};
                <br>
                Заказчик экспертизы: {{ conclusionItem.COMPANY.NAME }}; Внешнеэкономическая операция: {{ conclusionItem.VEO.NAME }};<br/>
                Страна (страны) операции: {{ countries() }}; Назначил {{ conclusionItem.SUPER_MANAGER.NAME }}
              </h2>
              <h3 class="content-suptitle" v-if="conclusionItem.UF_NUMBER">
                Заключение № {{ conclusionItem.UF_NUMBER }}<br/>
                <span v-if="conclusionItem.UF_DATE_FINISHED">дата выдачи: {{ conclusionItem.UF_DATE_FINISHED }}</span>
              </h3>
            </div>
            <div class="page-top-title__item text-right">
              <div v-if="conclusionItem.UF_IS_ECP" style="display: inline-block"
                   v-tooltip="{ content: new Object(() => ecpInfo()), loadingContent: '<i>Загрузка...</i>', classes: 'message' }"
              >
                <span class="e-signature">эцп</span>
                <span class="e-signature_data">{{ conclusionItem.UF_SIGN_ECP_DATE | dateFormat }}</span>
              </div>
              <input v-if="currentUser.ACTIVE_ROLE_CODE === 'expert_org_assignee' && conclusionItem.UF_STATUS_ID === 4"
                     class="link_style-blue"
                     @click="startReturn"
                     type="button"
                     value="Вернуть на доработку"/>
              <input v-if="currentUser.ACTIVE_ROLE_CODE === 'expert_org_assignee' && conclusionItem.UF_STATUS_ID === 4"
                     class="link_style-blue"
                     @click="startECP"
                     type="button"
                     value="Подписать эцп"/>
              <input v-if="currentUser.ACTIVE_ROLE_CODE === 'expert_org_manager' && !conclusionItem.UF_NUMBER" class="link_style-blue"
                     :disabled="!conclusionItem.UF_IS_ACTIVE_BTN_RN===0"
                     :class="{'link-disabled': conclusionItem.UF_IS_ACTIVE_BTN_RN===0}"
                     @click="setNumber"
                     type="button"
                     value="Получить рег. № заключения"/>
              <input v-if="conclusionItem.UF_IS_VIEW_BTN_SEND" class="link_style-blue"
                     :disabled="!conclusionItem.UF_IS_ACTIVE_BTN_RN===0"
                     :class="{'link-disabled': conclusionItem.UF_IS_ACTIVE_BTN_SEND===0}"
                     @click="sendConclusions"
                     type="button"
                     value="Отправить уполномоченному"/>
            </div>
          </div>
          <div class="content-tab-area" v-if="!isConclusionsLoading">
            <ul class="content-tab-menu">
              <li class="tab-menu__item" :class="{tab_active: step === 1}" @click="setStep(1)">Общие сведения</li>
              <li class="tab-menu__item" :class="{tab_active: step === 2}" @click="setStep(2)">Сведения о Товарах /
                Продукции
              </li>
              <li class="tab-menu__item" :class="{tab_active: step === 3}" @click="setStep(3)">Анализ позиций
                контрольных
                списков
              </li>
              <li class="tab-menu__item" :class="{tab_active: step === 4}" @click="setStep(4)">Запреты и ограничения
              </li>
              <li class="tab-menu__item" :class="{tab_active: step === 5}" @click="setStep(5)">Выводы</li>
              <li class="tab-menu__item" :class="{tab_active: step === 6}" @click="setStep(6)">Дополнительная информация
              </li>
            </ul>
            <MainInfo v-if="step === 1"/>
            <ProductInfo v-if="step === 2"/>
            <Review v-if="step === 3"/>
            <Restriction v-if="step === 4"/>
            <Output v-if="step === 5"/>
            <OptionInfo v-if="step === 6"/>
            <div class="content-tab__panel tab_active">
              <div class="container-fluid">

                <div class="btn-box">
                  <div class="link_style-blue" v-if="conclusionItem.UF_IS_EDIT" @click="editConclusion">сохранить</div>
                </div>
              </div>
            </div>

            <div class="modal fade in show" tabindex="-1" v-if="showReturnModal" role="dialog"
                 aria-labelledby="myModalLabel">
              <div class="modal-dialog " style="width: 490px" role="document">
                <div class="modal-content">
                  <div class="modal-add-document"
                       style="z-index: 10000;width: 490px">
                    <div class="modal-header main-clear">
                      <span class="modal-title">Отправить на доработку</span>
                      <a @click="showReturnModal=false" class="modal-exit stl-FR"></a>
                    </div>
                    <div class="modal-body">
                      <div class="modal_row main-clear">
                        <span class="modal-field_name">Комментарий</span>
                        <span>
                                         <textarea style="width: 465px;height: 100px" v-model="returnComment" class="main_input "/>
                                    </span>
                      </div>
                      <div class="modal_row main-clear">
                        <button class="link_style-blue modal_btn_wid" style="width: 30%"
                                @click="changeDocStatus"
                                v-if="statusCard.UF_STATUS_DOC_ID > 0">
                          отправить
                        </button>
                        <div class="link_style-white stl-FR modal_btn_wid" style="width: 30%"
                             @click="showReturnModal=false">
                          отмена
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="modal fade in show text-left" tabindex="-1" v-if="showEcpModal" role="dialog"
                 aria-labelledby="myModalLabel">
              <div class="modal-dialog " style="width: 490px" role="document">
                <div class="modal-content">
                  <div class="modal-add-document"
                       style="z-index: 10000;width: 490px">
                    <div class="modal-header main-clear">
                      <span class="modal-title">Подпись заключения</span>
                      <a @click="showEcpModal = false" class="modal-exit stl-FR"></a>
                    </div>
                    <div class="modal-body">
                      <div v-if="!ecpPluginEnabled" style="color: red;">
                        Плагин не активен
                      </div>
                      <div v-else style="color: green;">
                        Плагин загружен.
                      </div>
                      <br/>
                      <div class="modal_row main-clear">
                        <span class="modal-field_name">Укажите сертификат подписи</span>
                        <span>
                                         <select style="width: 465px" v-model="ecpCert" class="main_input main_select">
                                           <option :key="cert.text" v-for="cert in ecpCerts" :value="cert"
                                           >{{ cert.text }}
                                        </option>
                                        </select>
                                    </span>
                      </div>

                      <div class="modal_row main-clear">
                        <button class="link_style-blue modal_btn_wid" style="width: 46%"
                                :disabled="ecpCert === null"
                                @click="Common_SignCadesBES_File(item)"
                        >
                          подписать
                        </button>
                        <div class="link_style-white stl-FR modal_btn_wid" style="width: 30%"
                             @click="showEcpModal = false">
                          отмена
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
/*global cadesplugin*/
import MainMenu from "@/components/cabinet/MainMenu";
import Header from "@/views/site/Header";
import Footer from "@/views/site/Footer";
import MainInfo from "@/components/cabinet/conclusion/MainInfo";
import OptionInfo from "@/components/cabinet/conclusion/OptionInfo";
import Output from "@/components/cabinet/conclusion/Output";
import ProductInfo from "@/components/cabinet/conclusion/ProductInfo";
import Restriction from "@/components/cabinet/conclusion/Restriction";
import Review from "@/components/cabinet/conclusion/Review";
import {mapGetters} from "vuex";
import {ConclusionService} from "@/common/api.service";
import {Funcs} from "@/common/funcs";
import moment from "moment";

export default {
  name: "ConclusionSettings",
  components: {MainMenu, Header, Footer, MainInfo, OptionInfo, Output, ProductInfo, Restriction, Review},
  data() {
    return {
      step: 1,
      toasterErrors: [],
      showEcpModal: false,
      ecpPluginEnabled: false,
      ecpCert: null,
      ecpCerts: [],
      showReturnModal: false,
      returnComment: ""
    }
  },
  computed: {
    ...mapGetters([
      "conclusionItem",
      "directory",
      "isConclusionsLoading",
      "currentUser"
    ]),
  },
  async mounted() {
    await this.$store.dispatch('fetchDirectories', [
      "status_request", "country"
    ]);
    await this.fetchItem()
  },
  methods: {
    countries() {
      let s = []
      for (let i = 0; i < this.conclusionItem.REQUEST.UF_COUNTRY_ID.length; i++) {
        s.push(Funcs.getDirectoryValue(this.directory.country, this.conclusionItem.REQUEST.UF_COUNTRY_ID[i]).UF_NAME)
      }
      return s.join(", ")
    },
    async fetchItem() {
      this.$store.dispatch('fetchConclusionItem', this.$route.params.id).then(() => {
        document.title = unescape(this.conclusionItem.META_TITLE);
        this.isLoaded = true
        if (this.conclusionItem.TN_VED_GROUP) {
          for (let i = 0; i < this.conclusionItem.TN_VED_GROUP.length; i++) {
            if (!this.conclusionItem.TN_VED_GROUP[i].RAZDEL_CONTROL_LIST) {
              this.conclusionItem.TN_VED_GROUP[i].RAZDEL_CONTROL_LIST = []
            }
            if (!this.conclusionItem.TN_VED_GROUP[i].COMPARATIVE_ANALISYS) {
              this.conclusionItem.TN_VED_GROUP[i].COMPARATIVE_ANALISYS = []
            }
          }
        }
      }, this)
    },
    editConclusion() {
      this.toasterErrors.forEach(function (err) {
        err.goAway(0);
      });
      ConclusionService.editConclusion(this.conclusionItem.ID, this.conclusionItem).then(({data}) => {
        this.fetchItem()
        if (data.error) {
          data.errorAr.forEach(function (err) {
            this.toasterErrors[this.toasterErrors.length] = this.$toasted.show(
                err.TEXT,
                {
                  theme: "bubble",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.toasterErrors.forEach(function (err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                }
            );
          }, this);
        } else {
          this.toasterErrors[this.toasterErrors.length] = this.$toasted.show(
              'Заключение сохранено',
              {
                theme: "green",
                position: "bottom-right",
                duration: 3000,
                action: [
                  {
                    text: "Закрыть",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  }
                ]
              }
          );
        }
      }, this)
    },
    setStep(step) {
      this.step = step;
    },
    async setNumber() {
      ConclusionService.setNumber(this.conclusionItem.ID).then(({data}) => {
        this.fetchItem()
        if (data.error) {
          data.errorAr.forEach(function (err) {
            this.toasterErrors[this.toasterErrors.length] = this.$toasted.show(
                err.TEXT,
                {
                  theme: "bubble",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.toasterErrors.forEach(function (err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                }
            );
          }, this);
        }
      }, this)
    },
    async sendConclusions() {
      ConclusionService.sendConclusions(this.conclusionItem.ID).then(({data}) => {
        this.fetchItem()
        if (data.error) {
          data.errorAr.forEach(function (err) {
            this.toasterErrors[this.toasterErrors.length] = this.$toasted.show(
                err.TEXT,
                {
                  theme: "bubble",
                  position: "bottom-right",
                  duration: null,
                  action: [
                    {
                      text: "Закрыть",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      }
                    },
                    {
                      text: "Закрыть все",
                      onClick: () => {
                        this.toasterErrors.forEach(function (err) {
                          err.goAway(0);
                        });
                      }
                    }
                  ]
                }
            );
          }, this);
        }
      }, this)
    },
    startECP() {
      if (!this.conclusionItem.UF_IS_DONE_ECP) {
        //return
      }
      this.showEcpModal = true;
      this.Common_CheckForPlugIn();
    },
    startReturn() {
      this.showReturnModal = true;
      this.returnComment = "";
    },
    Common_CheckForPlugIn() {
      cadesplugin.set_log_level(cadesplugin.LOG_LEVEL_DEBUG);
      let canAsync = !!cadesplugin.CreateObjectAsync;
      if (canAsync) {
        return this.CheckForPlugIn_Async();
      } else {
        //return CheckForPlugIn_NPAPI();
      }
    },
    CheckForPlugIn_Async() {
      this.ecpPluginEnabled = true;
      let _this = this;
      cadesplugin.async_spawn(function* () {
        //let oAbout = yield cadesplugin.CreateObjectAsync("CAdESCOM.About");
        yield _this.FillCertList_Async();
      });
    },
    FillCertList_Async() {
      let _this = this;
      cadesplugin.async_spawn(function* () {
        let oStore;
        try {
          oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
          if (!oStore) {
            alert("Ошибка чтения сертификатов ЭЦП");
            return;
          }

          yield oStore.Open();
        } catch (ex) {
          alert("Ошибка чтения сертификатов ЭЦП");
        }

        let CertificatesObj = yield oStore.Certificates;

        let certCnt = yield CertificatesObj.Count;
        if (certCnt === 0) {
          //throw "Сертификаты не найдены";
        }
        try {
          yield oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
          let certs = yield oStore.Certificates;
          let certCnt = yield certs.Count;
          for (let i = 1; i <= certCnt; i++) {
            let cert = yield certs.Item(i);

            let oOpt = {
              text: "",
              value: ""
            };
            oOpt.text = yield cert.SubjectName;
            oOpt.value = yield cert.Thumbprint;
            _this.ecpCerts.push(oOpt);
          }
          yield oStore.Close();
        } catch (ex) {
          console.log(ex);
        }
        console.log(_this.ecpCerts)
      });
    },
    Common_SignCadesBES_File(item) {
      let canAsync = !!cadesplugin.CreateObjectAsync;
      if (canAsync) {
        return this.SignCadesBES_Async_File(item);
      } else {
        //return SignCadesBES_NPAPI_File(id);
      }
    },
    SignCadesBES_Async_File(item) {
      let _this = this;
      cadesplugin.async_spawn(function* () {
        try {
          //FillCertInfo_Async(certificate);
          let oSigner;
          let errormes = "";
          try {
            oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
          } catch (err) {
            errormes = "Failed to create CAdESCOM.CPSigner: " + err.number;
            throw errormes;
          }
          let oSigningTimeAttr = yield cadesplugin.CreateObjectAsync(
              "CADESCOM.CPAttribute"
          );

          let CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
          yield oSigningTimeAttr.propset_Name(
              CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME
          );
          let oTimeNow = new Date();
          yield oSigningTimeAttr.propset_Value(oTimeNow);
          let attr = yield oSigner.AuthenticatedAttributes2;
          yield attr.Add(oSigningTimeAttr);

          let oDocumentNameAttr = yield cadesplugin.CreateObjectAsync(
              "CADESCOM.CPAttribute"
          );
          let CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;
          yield oDocumentNameAttr.propset_Name(
              CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME
          );
          yield oDocumentNameAttr.propset_Value("Document Name");
          yield attr.Add(oDocumentNameAttr);

          let oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
          try {
            oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
          } catch (e) {
            alert("Ошибка при открытии хранилища");
            console.log(e);
            return;
          }

          let CertificatesObj = yield oStore.Certificates;
          let CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
          let oCerts = yield CertificatesObj.Find(
              CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
              _this.ecpCert.value
          );

          if (oCerts.Count == 0) {
            errormes = "Certs not found";
            throw errormes;
          }

          let oCert = yield oCerts.Item(1);
          let sName = yield oCert.SubjectName;

          if (oSigner) {
            yield oSigner.propset_Certificate(oCert);
          } else {
            errormes = "Failed to create CAdESCOM.CPSigner";
            throw errormes;
          }

          let oSignedData = yield cadesplugin.CreateObjectAsync(
              "CAdESCOM.CadesSignedData"
          );
          let CADES_BES = 1;let buff = new Buffer(_this.conclusionItem.UF_NUMBER + _this.conclusionItem.UF_COMPANY_EXPERT_ID + _this.conclusionItem.COMPANY.COMPANY_ID);
          let dataToSign = buff.toString('base64');
          if (dataToSign) {
            yield oSignedData.propset_ContentEncoding(1); //CADESCOM_BASE64_TO_BINARY
            yield oSignedData.propset_Content(dataToSign);
            yield oSigner.propset_Options(1); //CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN

            _this.ecpValue = yield oSignedData.SignCades(oSigner, CADES_BES);
            _this.showECP = false;
            _this.ecpRequest(item)
            let sn = sName.split(",");
            sn.forEach(function (v) {
              let r = v.replace("CN=", "");
              if (r.length !== v.length) {
                _this.ecpEnsurer = r.trim();
              }
            });

          }
          //alert(Signature)
        } catch (err) {
          console.log("sign err", err);
        }
      });
    },
    ecpRequest() {
      ConclusionService.setECPRequest(this.conclusionItem.ID, {UF_SIGN_ECP: this.ecpValue}).then(({data}) => {
        if (!data.error) {
          this.showEcpModal = false
          this.fetchItem()
        }
      }, this)
    },
    returnWorkExpertise() {
      ConclusionService.returnWorkExpertise(this.conclusionItem.ID, {UF_COMMENT_COMMISIONER: this.returnComment}).then(({data}) => {
        if (!data.error) {
          this.showReturnModal = false
          this.fetchItem()
        }
      }, this)
    },
    async ecpInfo() {
      return await ConclusionService.getECPInfoConclusions(this.conclusionItem.ID).then(({data}) => {
        return `<div class="modal-content">
<div class="text-center"><span class="modal-title">Заключение подписано <br> электронной
подписью</span></div>
<div class="modal-body">
<div class="modal_row modal_flex">
<span class="modal-field_name">Сертификат</span>
<span>${data.result.SERTIFICATE_NUMBER}</span>
</div>
<div class="modal_row modal_flex">
<span class="modal-field_name">Организация</span>
<span>${data.result.COMPANY}</span>
</div>
<div class="modal_row modal_flex">
<span class="modal-field_name">Владелец</span>
<span>${data.result.OWNER_FIO}</span>
</div>
<div class="modal_row modal_flex">
<span class="modal-field_name">Должность</span>
<span>${data.result.POSITION}</span>
</div>
<div class="modal_row modal_flex">
<span class="modal-field_name">Действителен</span>
<span>${data.result.DATE_USE_SERTIFICATE}</span>
</div>
</div>
</div>`
      }).catch(() => 'ERROR')
    }
  },
  filters: {
    dateFormat(date) {
      return moment(date).format("DD.MM.YYYY");
    },
  },
}
</script>

<style scoped>

</style>